<template>
  <div class="not-found">
    <img src="/imgs/404.png" alt="" width="120px">
    <p class="not-found-text">糟糕，页面走失了！再检查下网址是否正确！</p>
    <span class="not-found-btn" @click="onFresh">刷新页面</span>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    onFresh () {
      window.location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.not-found {
  padding-top: 180px;
  text-align: center;
  color: #909399;
  .not-found-text {
    margin: 15px 0;
  }
  .not-found-btn {
    color: #409eff;
  }
}
</style>
